export enum ExternalUserRole {
    REVIEWER = 3,
    AE_DESIGNER = 4,
    PROJECT_MANAGER = 5
}